import { render, staticRenderFns } from "./cropper-avator-ai.vue?vue&type=template&id=16e0bd94&scoped=true"
import script from "./cropper-avator-ai.vue?vue&type=script&lang=js"
export * from "./cropper-avator-ai.vue?vue&type=script&lang=js"
import style0 from "./cropper-avator-ai.vue?vue&type=style&index=0&id=16e0bd94&prod&scoped=true&lang=less"
import style1 from "./cropper-avator-ai.vue?vue&type=style&index=1&id=16e0bd94&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e0bd94",
  null
  
)

export default component.exports